export const getCustomFields = (state) => state.customFields
